import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "w-full" };
const _hoisted_2 = {
    class: "xl:hidden bg-white grow shadow overflow-hidden sm:rounded-md m-2",
    style: { "max-height": "435px" }
};
const _hoisted_3 = { class: "bg-white shadow overflow-hidden sm:rounded-md m-2 xl:grow" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_activity_feed = _resolveComponent("activity-feed");
    const _component_approval_messages = _resolveComponent("approval-messages");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_activity_feed)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createBlock(_component_approval_messages, {
                key: _ctx.keyIndex,
                "doc-type": _ctx.docType,
                "form-data": _ctx.formData,
                onReply: _ctx.reloadApprovalMessages
            }, null, 8, ["doc-type", "form-data", "onReply"]))
        ])
    ]));
}
